import { Injectable } from '@angular/core';

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';

@Injectable()
export class GlobalsProvider {

  apiURL: string = 'https://m.mi-help.ru/api/';
  uuid: string = '';
  id_user: string = '';
  token: string = '';
  id_lang: string = '';
  runned_in_app: string = '1';
  phrases: any;
  new_ans: string;
  push_id: string;
  menu_sellang: string = 'Выберите язык';
  menu_chlang: string = 'Сменить язык';
  menu_reqs: string = 'Мои обращения';
  menu_info: string = 'Полезная информация';
  menu_news: string = 'Новости';
  menu_med: string = 'Консультация врача';
  menu_urist: string = 'Консультация юриста';
  menu_zapis: string = 'Запись на прием';
  menu_map: string = 'Карта служб помощи';
  menu_about: string = 'О проекте';

  constructor(public http: Http) {
    console.log('Hello GlobalsProvider Provider');
  }

  stat(page: string = '') {
    this.http.get(this.apiURL + '?act=stat&id_user=' + this.id_user + '&page='+page)
    .timeout(20000)
    .map(res => res.json())
    .subscribe(
      data => {

      },
      err => {
        
      }
    );
  }  

}



// WEBPACK FOOTER //
// ./src/providers/globals/globals.ts